import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';
import { getBeWiseCuratedCampList, saveCity } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';


class bewiseCuratedCamps extends Component {

    constructor(props) {
        super(props);
        var url = new URL(window.location.href);
        var location = url.searchParams.get("location");
        var auth_data = JSON.parse(localStorage.getItem("user_data"));
        this.state = {
              logged: localStorage.getItem("authentication"),
              auth_data: JSON.parse(localStorage.getItem("user_data")),
              location: location ? location : (auth_data.access_location ? auth_data.access_location : 'Bengaluru'),
              camplist: [],
              openedAdd:false
        };

        this.getBeWiseCuratedCampList();
    }


    componentDidMount() {

      var THIS = this;
      $(document).on('click', '.remove_camp', function () {
        var delete_id = $(this).data("id");
        THIS.setState({
          delete_id: delete_id
        })
      });


    }

    openAddBox= () => {

      this.setState({openedAdd:true});
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
      
    };  


    saveCity = ()=>{
        
        let req = JSON.stringify({
            city:this.state.city,
            latitude:this.state.latitude,  
            longtitude:this.state.longtitude
        })

        saveCity(req).then((response) => {
          
          if(response.status==1){

                alert("success");
                this.getCityList();

          }else{
                alert("error");
          }
      
        });
     

    }

    getBeWiseCuratedCampList = () => {
      const { login_id, role } = this.state.auth_data;
      let ins = JSON.stringify({
        vendor_id: login_id,
        role: role
      });
      getBeWiseCuratedCampList(ins).then((res) => {
        if (res.status == 1) {
          this.setState({
            camplist: res.data
            
          });
        } else {
          this.setState({
            camplist: [],
          });
        }
      });
    }    

    render() {

        const { camplist } = this.state;

        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">BeWise Curated Camps</h4>
                 
       
                  <div class="row col-lg-12">
                    
                      <div class="pt-3 table-responsive">
                    <table class="table table-bordered table-striped table-sm">
                      <thead class="thead-dark">
                        <tr>
                          <th >
                            <strong>S.No</strong>
                          </th>
                          <th >
                            <strong>Camp Name</strong>
                          </th>
                     
                          <th>
                            <strong>Approval Status</strong>
                          </th>

                          <th >
                            <strong>Published</strong>
                          </th>

                          <th >
                            <strong>Action</strong>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                      {camplist.map((item, i) => {     
                      
                       return <tr>
                          <td  >
                            {i+1}
                          </td>
                                                  
                        
                          <td  >
                            {item.camp_name}
                          </td>
                         
                          <td   dangerouslySetInnerHTML={{__html: item.status}}>
                            
                          </td>
                         
                          <td   dangerouslySetInnerHTML={{__html: item.published}}>
                            
                          </td>
                          
                          <td  class="actionbtns" dangerouslySetInnerHTML={{__html: item.action}} />                             

                        </tr>

                      })

                      }
                       
                      </tbody>
                    </table>
                  </div>


                  </div>
                    
                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default bewiseCuratedCamps;


// WEBPACK FOOTER //
// ./src/components/bewise/bewiseCuratedCamps.jsx